import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import LoginModal from "../components/Login/LoginModal";
import beatiorLogo from "../assets/beatior-logo.png";

function Header() {
  const [showLoginModal, setShowLoginModal] = useState(false);
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false); // Mobile menu state
  const navigate = useNavigate();

  const handleOpenModal = () => setShowLoginModal(true);
  const handleCloseModal = () => setShowLoginModal(false);

  const handleLogout = () => {
    localStorage.clear();
    setIsLoggedIn(false);
    navigate("/"); // Redirect to home page
  };

  const handleLoginSuccess = () => {
    const token = localStorage.getItem("token");
    setIsLoggedIn(!!token);
    setShowLoginModal(false);
  };

  const toggleMobileMenu = () => setMobileMenuOpen((prev) => !prev);

  useEffect(() => {
    const token = localStorage.getItem("token");
    setIsLoggedIn(!!token);
  }, []);

  return (
    <>
      <header id="header" className="fixed-top">
        <div className="container">
          <div className="logo float-left">
            <a href="#intro" className="scrollto">
              <img
                src={beatiorLogo}
                alt="Beatior Logo"
                className="img-fluid logo"
              />
            </a>
          </div>
          {/* Mobile Menu Toggle */}
          <button
            className="mobile-nav-toggle"
            onClick={toggleMobileMenu}
            aria-label="Toggle navigation"
          >
            ☰
          </button>
          <nav className={`main-nav ${mobileMenuOpen ? "mobile-menu-open" : ""}`}>
            <ul>
              <li className="active">
                <a href="/#intro">Home</a>
              </li>
              <li>
                <a href="/#about">About Us</a>
              </li>
              <li>
                <a href="/#services">Services</a>
              </li>
              <li>
                <a href="/careers">Careers</a>
              </li>
              <li>
                <a href="/#contact">Contact Us</a>
              </li>
              {isLoggedIn ? (
                <>
                  <li>
                    <a href="/profile">Profile</a>
                  </li>
                  <li>
                    <a href="/dashboard">Dashboard</a>
                  </li>
                  <li>
                    <button className="btn btn-danger login-btn" onClick={handleLogout}>
                      Logout
                    </button>
                  </li>
                </>
              ) : (
                <li>
                  <button className="btn btn-primary login-btn" onClick={handleOpenModal}>
                    Login
                  </button>
                </li>
              )}
            </ul>
          </nav>
        </div>
      </header>

      {showLoginModal && (
        <LoginModal onClose={handleCloseModal} onLoginSuccess={handleLoginSuccess} />
      )}
    </>
  );
}

export default Header;
